// =====================================================================
// src/components/intl-acca/CLVConfidencePill.tsx
// =====================================================================
// Pure presentational pill for CLV confidence + percentage-point value.
// Renders the honest-empty path when `clv_pp` is null (no Pinnacle close
// has flowed yet for this leg). Never invents a value the DB doesn't have.

import type { CLVConfidence } from "../../db/intl-acca-types";
import { formatClvPp } from "../../db/intl-acca-types";

export interface CLVConfidencePillProps {
  /** Set at selection time, NOT NULL at the DB. */
  confidence: CLVConfidence;
  /** Settled CLV value; null until Pinnacle close exists. */
  clv_pp: number | null;
  /** When true, render only the confidence dot + label (no value). */
  hideValue?: boolean;
}

export function CLVConfidencePill({
  confidence,
  clv_pp,
  hideValue,
}: CLVConfidencePillProps): JSX.Element {
  return (
    <span
      className="ia-pill ia-pill-ghost"
      aria-label={`CLV ${confidence}, ${clv_pp === null ? "unsettled" : formatClvPp(clv_pp)}`}
    >
      <span
        aria-hidden
        className={`ia-clv-dot ia-clv-dot-${confidence}`}
      />
      <span>CLV {confidence}</span>
      {hideValue ? null : (
        <span style={{ marginLeft: 4 }}>
          {clv_pp === null ? "—" : formatClvPp(clv_pp)}
        </span>
      )}
    </span>
  );
}
